import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Circle, Clock9, MessageSquare } from 'lucide-react';
import React from 'react';

// The Email interface should match the one in UnifiedInboxBasePage.
export interface SMS {
  id: string;
  threadId?: string | null;
  author: string;
  date: string;
  body: string;
  read: boolean;
  messages?: SMS[];
}

export interface SMSListProps {
  smss: SMS[];
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  onSelectSms: (smsId: string) => void;
  selectedSmsId: string | null;
  onOpenSMSThreadDialog: (opn: boolean) => void;
}

const SMSList: React.FC<SMSListProps> = ({
  smss,
  searchTerm,
  onSearchTermChange,
  onSelectSms,
  selectedSmsId,
  onOpenSMSThreadDialog,
}) => {
  console.log('ssss', smss);
  return (
    <div className="flex-1 space-y-3 overflow-y-auto">
      {smss.length < 1 ? (
        <div className="flex h-full items-center justify-center text-sm text-gray-400">
          No Text Messages found
        </div>
      ) : (
        smss.map(sms => (
          sms.messages && sms.messages.length > 1 && (
          <Card
            key={sms.id}
            onClick={() => {
              onSelectSms(sms.id);
              onOpenSMSThreadDialog(true);
            }}
            className={`relative cursor-pointer hover:bg-gray-50 ${
              selectedSmsId === sms.id ? 'bg-blue-100' : 'bg-white'
            } rounded-md shadow-none`}
          >
            <CardContent className="p-3 pl-6">
              <div className="flex w-full items-start">
                <div className="mr-2">
                  <MessageSquare className="mt-2 h-5 w-5 text-green-500" />
                </div>
                <div className="w-full">
                  <div className="mt-1 flex items-center justify-between text-base">
                    <div className="w-[400px] truncate">{sms.body}</div>
{/* 
                    <div className="mt-1 flex items-center space-x-1 text-xs text-gray-600">
                      {sms.read ? (
                        <CheckCircle className="h-4 w-4 text-green-500" />
                      ) : (
                        <Circle className="h-3 w-3 fill-yellow-500 text-yellow-500" />
                      )}
                      <span>{sms.read ? 'Read' : 'Unread'}</span>
                    </div> */}
                  </div>

                  <div className="mt-1 flex items-center text-xs text-gray-500">
                    <Clock9 className="mr-1 h-3 w-3" />
                    {new Date(sms.date).toLocaleDateString()}{' '}
                    {new Date(sms.date).toLocaleTimeString()}
                  </div>

                  <div className="mt-1 flex items-center text-xs text-gray-500">
                    From {sms.author}
                  </div>

                  {sms.messages && sms.messages.length > 1 && (
                    <div className="mt-1 text-xs text-gray-500">
                      {sms.messages.length} messages
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="mt-2 text-xs text-gray-500 line-clamp-2">{email.body}</div> */}
            </CardContent>
            </Card>
          )
        ))
      )}
    </div>
  );
};

export default SMSList;
